import { styled } from '@mui/material';

import { Link } from '../Link/styled';

export const SmallSizeLink = styled(Link)(({ theme }) => ({
  ...theme.typography['body-2-md'],
  color: theme.palette.grey[500],
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  gap: 4,

  '& svg': {
    height: 20,
    marginTop: -3,
    width: 20,
  },
}));
